import { render } from "./DownloadBox.vue?vue&type=template&id=6a958a3b"
import script from "./DownloadBox.vue?vue&type=script&lang=js"
export * from "./DownloadBox.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.3.1_@vue+compiler-sfc@3.3.11_vue@3.3.11_webpack@5.89.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__